export interface PractitionerApplicationRequest {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  disciplines: Array<'TATTOO' | 'PIERCING'>;
  password: string;
  confirmPassword: string;
  acceptTerms: boolean;
  acceptPrivacy: boolean;
  message?: string;
  portfolioUrl?: string;
}

export interface PractitionerApplicationResponse {
  success: boolean;
  message?: string;
  data?: {
    id: string;
    status: 'PENDING' | 'APPROVED' | 'REJECTED';
  };
  errors?: any;
}

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

class PractitionerApplicationApi {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${API_BASE_URL}/api/practitioner-applications`;
  }

  async apply(data: PractitionerApplicationRequest): Promise<PractitionerApplicationResponse> {
    const response = await fetch(`${this.baseUrl}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });

    const result = await response.json().catch(() => ({}));
    if (!response.ok) {
      return {
        success: false,
        message: result?.message || 'Application failed',
        errors: result?.errors,
      };
    }
    return result;
  }
}

export const practitionerApplicationApi = new PractitionerApplicationApi();
export default practitionerApplicationApi;

